module.exports = __webpack_public_path__ + "static/img/메달-인물.b825c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/메달-인물.png
// module id = wVeo
// module chunks = 0